'use strict';

import SimpleMessages from './simple-messages';

/*

  How to use base Form functionality

  Template:
  1. Form name="$ctrl.form" id="form" ng-submit="$ctrl.save()"
  2. Include form header at the top:
     <ng-include src="'form-header.html'">
     </ng-include>
  3. Your controls should be disabled following !$ctrl.editing:
     ng-disabled="!$ctrl.editing"
  4. Color for disabled controls should be just inherited:
     .md-input[disabled] {
       color: inherit !important;
     }

  Controller:
  1. Should inherit from us:
     class MyController extends FormController {

  2. Should call super with model instance, model name (for displaying
     purposes) and the corresponding Service (which should inherit from
     BaseService):

     super(employee, 'Empleado', EmployeesService);

 */

class FormController {
  constructor(model, modelName, Service, focus, collectionName) {
    Object.assign(this, {
      model,
      modelName,
      Service,
      focus,
      collectionName
    });

    if (!this.model) {
      this.model = this.Service.create();
      this.editing = true;
    } else {
      this.editable = true;
    }
    if (this.focus) this.focus.focusOn('focusMe');
    if (collectionName) {
      this.newItemUrl = `/${collectionName}/new`;
    }
  }

  $onInit() {}

  edit() {
    if (this.beforeEdit) {
      this.beforeEdit();
    }
    this.editable = false;
    this.editing = true;
    this.modelCopy = JSON.parse(JSON.stringify(this.model));
    if (this.focus) this.focus.focusOn('focusMe');
  }

  save() {
    if (this.beforeSave) {
      this.beforeSave();
    }
    let firstTimeSave = false;
    if (!this.model.id) {
      firstTimeSave = true;
    }
    if (this.form.$valid) {
      this.showSpin = true;
      return this.model
        .$save()
        .then(() => {
          if (this.afterModelSave) {
            return this.afterModelSave();
          }
        })
        .then(() => {
          this.showSpin = false;
          this.editable = true;
          this.editing = false;
          if (firstTimeSave) {
            this.updateLocation();

            if (this.afterFirstSave) {
              setTimeout(() => {
                this.afterFirstSave();
              }, 0);
            }
          }
          if (this.afterSave) {
            this.afterSave();
          }
        });
    } else {
      // eslint-disable-next-line no-console
      console.debug(this.form);
      return Promise.reject(new Error('invalid form'));
    }
  }

  reset() {
    Object.assign(this.model, this.modelCopy);
    this.form.$setUntouched();
    this.form.$setPristine();
    this.editable = true;
    this.editing = false;

    if (this.afterReset) {
      this.afterReset();
    }
  }

  updateLocation() {
    if (!this.$state) {
      // eslint-disable-next-line no-console
      console.debug('Missing this.$state, cannot update location');
      return;
    }

    if (!this.collectionName) {
      // eslint-disable-next-line no-console
      console.debug('Missing this.collectionName, cannot update location');
      return;
    }

    this.$state.go('edit' + this.Service.Model.modelName, {
      id: this.model.id
    });
  }

  goToNew() {
    this.$state.go('new' + this.Service.Model.modelName);
  }
}

Object.assign(FormController.prototype, SimpleMessages);
export default FormController;
